import { displayMessage } from '../../helpers/messages'
import GeneralContext from '../../context/GeneralContext/GeneralContext'
import React, { useContext, useEffect, useState } from 'react'
import { useGridApiRef } from '@mui/x-data-grid-pro'
import api from '../../services/api'
import { useNavigate, useParams } from "react-router-dom";
import styles from '../../services/styles';

import SL_Button from '../../components/buttons/Button'
import CreateNotification from './CreateNotification'
import NotificationFilters from '../../components/filters/NotificationFilters'
import { CloseOutlined, FilterOutlined, PlusCircleOutlined, UserAddOutlined } from '@ant-design/icons'
import column_grid_notification_list from '../grid_columns/column_grid_notification_list'
import { Button } from 'antd'
import { SL_Grid } from '../../components/grid/SL_Grid'

const { tc1, tc2, bc1, bc6 } = styles

export default function ListNotifications() {
    const navigate = useNavigate()
    const gridRef = useGridApiRef()

    const [notifications, setNotifications] = useState([])
    const [currentNotification, setCurrentNotification] = useState(null)
    const [isModalCreateNotificationVisible, setIsModalCreateNotificationVisible] = useState(false)
    const [isFiltersVisible, setIsFiltersVisible] = useState(false)

    const {
        setShowLoading,
        windowWidth,
        windowHeight,
        mobile_mode,
    } = useContext(GeneralContext)

    useEffect(() => {
        loadNotifications()
    }, [])

    async function loadNotifications(values) {
        const { data } = await api.notifications.listAll(values)
        gridRef.current.setSelectionModel([])
        setNotifications(data)
    }

    const handleRowChange = (e) => {
        setCurrentNotification(e?.row)
    }

    const handleOnCloseModalCreateNotification = async (loadData) => {
        if (loadData) {
            await loadNotifications()
        }
        setIsModalCreateNotificationVisible(false)
    }
    const handleOnOpenModalCreateNotification = () => {
        setIsModalCreateNotificationVisible(true)
    }

    const handleOnOpneFilters = () => {
        setIsFiltersVisible(true)
    }
    const handleOnCloseFilters = () => {
        setIsFiltersVisible(false)
    }

    return (
        <>
            {isModalCreateNotificationVisible && <CreateNotification handleOnCloseModal={handleOnCloseModalCreateNotification} handleOnSearchNotifications={loadNotifications} />}

            <div className="flex flex-col flex-1 h-full">
                <div className={`flex w-full bg-fit-red-700 p-2 rounded-tl-[4px] rounded-tr-[4px] flex-wrap ${mobile_mode ? 'flex-col items-center gap-4' : 'gap-2'}`}>
                    <div className='self-center text-white font-semibold text-base'>{displayMessage('NOTIFICATION_LIST')}</div>

                    <div className={`flex-1 flex flex-wrap gap-2 justify-end`}>

                        <SL_Button
                            type='default'
                            className={`flex items-center flex-1 ${mobile_mode ? 'w-[200px]' : 'max-w-[200px]'}`}
                            onClick={handleOnOpenModalCreateNotification}
                            icon={<PlusCircleOutlined className='text-base flex items-center' />}
                        >
                            <span className='text-fit-red-800 font-semibold flex-1'>
                                {displayMessage('REGISTER_NOTIFICATION')}
                            </span>
                        </SL_Button>

                        <Button
                            type='default'
                            shape="circle"
                            onClick={isFiltersVisible ? handleOnCloseFilters : handleOnOpneFilters}
                            icon={!isFiltersVisible ? <FilterOutlined className='text-fit-red-800 flex items-center justify-center' /> : <CloseOutlined className='text-fit-red-800 flex items-center justify-center' />}
                        >
                        </Button>
                    </div>
                </div>
                {
                    isFiltersVisible ?
                        <NotificationFilters handleOnSearchNotifications={loadNotifications} filterHeight={`40vh`} />
                        :
                        <div />
                }
                <div className={`w-full flex-1 min-h-[400px] smb:min-h-0`} >
                    <SL_Grid
                        rows={notifications ?? []}
                        apiRef={gridRef}
                        columns={column_grid_notification_list}
                        onRowClick={handleRowChange}
                    />
                </div>
            </div>
        </>
    )
}